// extracted by mini-css-extract-plugin
export default {"modalHolder":"style_modalHolder__7-k6b"};